// Copyright (c) 2016 Deere & Company

import Tab from '../../../../src/shared/state/tab';

export const getNavigationTabs = (props, hasSearchResultsLoaded) => {

    const navigationTabs = [
        new Tab({
            count: props.openPartRequestsCount,
            label: 'OPEN_PART_REQUESTS_WITH_COUNT',
            route: '/part-requests/open'
        }),
        new Tab({
            count: props.allPartRequestsCount,
            label: 'ALL_PART_REQUESTS_WITH_COUNT',
            route: '/part-requests/all'
        })
    ];

    if (hasSearchResultsLoaded) {

        navigationTabs.push(new Tab({
            count: props.filteredSearchResults.length,
            label: 'SEARCH_RESULTS_TAB',
            route: '/part-requests/search'
        }));

    }

    return navigationTabs;

};



// WEBPACK FOOTER //
// ./src/part-requests/shared/services/navigation-tabs.js